<template>
  <div>
    <v-dialog width="400px" title="Edit HCP" :visible.sync="dialogVisible" :scrollbar="false" @open="onOpen"
      @closed="onClosed">
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item prop="name" label="Name">
          <el-input v-model="form.name" placeholder="Please input name" maxlength="10" />
        </el-form-item>
        <el-form-item prop="city" label="City">
          <el-input v-model="form.city" placeholder="Please input city" maxlength="25" />
        </el-form-item>
        <el-form-item prop="hospital" label="Hospital / Institution">
          <el-input v-model="form.hospital" placeholder="Please input hospital / institution" maxlength="25" />
        </el-form-item>
        <el-form-item prop="department" label="Department">
          <el-input v-model="form.department" placeholder="Please input department" maxlength="25" />
        </el-form-item>
      </el-form>
      <div class="actions">
        <el-button type="primary" @click="onConfirm" :loading="loading">
          {{ loading ? "Saving" : "Save" }}
        </el-button>
        <el-button @click="onClosed">Cancel</el-button>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { trimValidate } from "../../utils/validator";
export default {
  name: "NewSEDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        seId: "",
        name: "",
        city: "",
        hospital: "",
        department: "",
        seType: 1,
        province:null
      },
      formRules: {
        name: [
          {
            required: true,
            validator: trimValidate("Please input name"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            validator: trimValidate("Please input city"),
            trigger: "blur",
          },
        ],
        hospital: [
          {
            required: true,
            validator: trimValidate("Please input hospital / institution"),
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            validator: trimValidate("Please input department"),
            trigger: "blur",
          },
        ],
      },
      mlList: [],
      loading: false,
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onOpen() {
      if (this.data) {
        this.$nextTick(() => {
          Object.assign(this.form, {
            seId: this.data.SEID,
            name: this.data.SEName,
            city: this.data.City,
            hospital: this.data.hospital,
            department: this.data.Department,
            province:this.data.province,
            seType: this.data.SEType,
          });
        });
      }
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.axios
            .post("/se/update", {
              seId: this.form.seId,
              seType: this.form.seType,
              name: this.form.name.trim(),
              city: this.form.city.trim(),
              province: this.form.province|| null,
              hospital: this.form.hospital.trim(),
              department: this.form.department.trim(),
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.onClosed();
                this.$emit("success");
                this.$message.success("Update HCP successfully");
              } else {
                this.$message.error(msg);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>
